import { render } from "./AssessmentRecommendationsSkeleton.vue?vue&type=template&id=63784102&scoped=true"
const script = {}

import "./AssessmentRecommendationsSkeleton.vue?vue&type=style&index=0&id=63784102&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63784102"]])

export default __exports__